export interface IPublisher {
  id?: string;
  name?: string | null;
}

export const defaultValue: Readonly<IPublisher> = {};
